import React, { Component } from "react"
import WorkbenchExportCardBasic from "components/workbenchExports/layout/WorkbenchExportCardBasic"

export class WorkbenchExportPage extends Component {
    render() { return (<WorkbenchExportCardBasic />) }
}
